import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { FilterLabel } from './FilterLabel';

export interface RadioFilterOption<T extends string> {
  label: string;
  value: T;
  hidden?: boolean;
}

export interface RadioFilterGroupProps<T extends string> {
  label: string;
  options: RadioFilterOption<T>[];
  value: T;
  onChange: (value: T) => void;
  columns?: number;
}

export function RadioFilterGroup<T extends string>({
  label,
  options,
  value,
  onChange,
  columns = 1,
}: RadioFilterGroupProps<T>) {
  return (
    <FormControl component="fieldset">
      <FilterLabel component="legend">{label}</FilterLabel>
      <RadioGroup
        value={value}
        onChange={(event) => onChange(event.target.value as T)}
        sx={{
          pl: 1,
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          columnGap: 2,
          '& .MuiButtonBase-root': { py: 0.25 },
          // Match the selected state of the toggle buttons (see toggleGroupSx)
          '& .MuiRadio-root.Mui-checked': { color: 'primary.main' },
        }}
      >
        {options
          .filter(({ hidden }) => !hidden)
          .map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio size="small" />}
              label={<Typography variant="body2">{option.label}</Typography>}
            />
          ))}
      </RadioGroup>
    </FormControl>
  );
}
